import { studentTestimonies } from "common/enums";
import FadeInOnScroll from "components/FadeIn";
import FadeInUpOnScroll from "components/FadeInUp";
import { useState } from "react";
import arrow_left_teachers from "../../../../../assets/images/app/home/arrow_left_teachers.png";
import arrow_right_teachers from "../../../../../assets/images/app/home/arrow_right_teachers.png";
import ellipse_testimony from "../../../../../assets/images/app/home/ellipse_testimony.svg";
import ellipse_testimony_one from "../../../../../assets/images/app/home/ellipse_testimony_one.svg";
import ellipse_testimony_two from "../../../../../assets/images/app/home/ellipse_testimony_two.svg";
import ellipse_valeur from "../../../../../assets/images/app/home/ellipse_valeur.svg";
import testimony_student_five from "../../../../../assets/images/app/home/testimony_student_five.png";
import testimony_student_four from "../../../../../assets/images/app/home/testimony_student_four.png";
import testimony_student_one from "../../../../../assets/images/app/home/testimony_student_one.png";
import testimony_student_six from "../../../../../assets/images/app/home/testimony_student_six.png";
import testimony_student_three from "../../../../../assets/images/app/home/testimony_student_three.png";
import testimony_student_two from "../../../../../assets/images/app/home/testimony_student_two.png";
import st from "../../../common.module.css";
import s from "./style.module.css";

const StudentsTestimonies = () => {

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
    const handleResize = () => {
        setIsMobile(window.innerWidth <= 767);
    };
    window.addEventListener('resize', handleResize);

    const [currentIndex, setCurrentIndex] = useState(0);

    const nextSlide = () => {
        if (currentIndex < studentTestimonies.length - 1) {
            setCurrentIndex(currentIndex + 1);
        }
    };

    const prevSlide = () => {
        if (currentIndex > 0) {
            setCurrentIndex(currentIndex - 1);
        }
    };

    return (
        <div className={s.mainContainer}>
            <div className={s.testimoniesBox}>
                <FadeInUpOnScroll>
                    <h1 className={s.title}>Témoignages</h1>
                </FadeInUpOnScroll>
                <img src={ellipse_testimony} className={s.ellipseTestimonies}></img>
                <FadeInOnScroll>
                    {isMobile ? <p className={s.subtitle}>Ce que nos élèves et étudiants<br />disent de nous</p> : <p className={s.subtitle}>Ce que nos élèves et étudiants disent de nous</p>}
                </FadeInOnScroll>
                {isMobile ? <div className={s.testimonies}>
                    <img src={testimony_student_one} className={`${st.floatAnimation} ${s.testimonyOneImage}`}></img>
                    <img src={testimony_student_two} className={`${st.floatAnimation} ${st.floatAnimationDelayed1} ${s.testimonyTwoImage}`}></img>
                    <img src={ellipse_valeur} className={s.ellipseOne}></img>
                    <img src={testimony_student_three} className={`${st.floatAnimation} ${st.floatAnimationDelayed2} ${s.testimonyThreeImage}`}></img>
                    <div className={s.currentTestimony}>
                        {/* <img src={student_testimony_one} className={s.currentTestimonyImage}></img> */}
                        {studentTestimonies.slice(currentIndex, currentIndex + 1).map((testimony: any, index: any) => (
                            <div key={index}>
                                <div className={s.currentTestimonyMessage}>{testimony.testimony}</div>
                                <div className={s.currentTestimonyName}>{testimony.firstname} {testimony.lastname.substring(0, 1) + "."}</div>
                                <div className={s.currentTestimonyUser}>{testimony.level}</div>
                            </div>
                        ))}
                        <img src={ellipse_testimony_one} className={s.ellipseTwo}></img>
                    </div>
                    <img src={testimony_student_four} className={`${st.floatAnimation} ${s.testimonyFourImage}`}></img>
                    <img src={testimony_student_five} className={`${st.floatAnimation} ${st.floatAnimationDelayed2} ${s.testimonyFiveImage}`}></img>
                    <img src={ellipse_testimony_two} className={s.ellipseThree}></img>
                    <img src={testimony_student_six} className={`${st.floatAnimation} ${st.floatAnimationDelayed1} ${s.testimonySixImage}`}></img>
                </div> : <div className={s.testimonies}>
                    <div style={{ width: "20%" }}>
                        <img src={testimony_student_one} className={`${st.floatAnimation} ${s.testimonyOneImage}`}></img>
                        <img src={testimony_student_two} className={`${st.floatAnimation} ${st.floatAnimationDelayed1} ${s.testimonyTwoImage}`}></img>
                        <img src={ellipse_valeur} className={s.ellipseOne}></img>
                        <img src={testimony_student_three} className={`${st.floatAnimation} ${st.floatAnimationDelayed2} ${s.testimonyThreeImage}`}></img>
                    </div>
                    <div className={s.currentTestimony}>
                        {/* <img src={student_testimony_one} className={s.currentTestimonyImage}></img> */}
                        {studentTestimonies.slice(currentIndex, currentIndex + 1).map((testimony: any, index: any) => (
                            <div key={index}>
                                <div className={s.currentTestimonyMessage}>{testimony.testimony}</div>
                                <div className={s.currentTestimonyName}>{testimony.firstname} {testimony.lastname.substring(0, 1) + "."}</div>
                                <div className={s.currentTestimonyUser}>{testimony.level}</div>
                            </div>
                        ))}
                        <img src={ellipse_testimony_one} className={s.ellipseTwo}></img>
                    </div>
                    <div style={{ width: "20%" }}>
                        <img src={testimony_student_four} className={`${st.floatAnimation} ${s.testimonyFourImage}`}></img>
                        <img src={testimony_student_five} className={`${st.floatAnimation} ${st.floatAnimationDelayed2} ${s.testimonyFiveImage}`}></img>
                        <img src={ellipse_testimony_two} className={s.ellipseThree}></img>
                        <img src={testimony_student_six} className={`${st.floatAnimation} ${st.floatAnimationDelayed1} ${s.testimonySixImage}`}></img>
                    </div>
                </div>}

                <div className={s.arrowBox}>
                    <div className={s.arrowLeftBox} onClick={prevSlide}>
                        <img src={arrow_left_teachers} style={{ height: "15px" }}></img>
                    </div>
                    <div className={s.arrowRightBox} onClick={nextSlide}>
                        <img src={arrow_right_teachers} style={{ height: "15px" }}></img>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StudentsTestimonies;